import moment from 'moment';

export function formatDateToWeb(value, format = 'DD/MM/YYYY'){
    if (value != null && value != '') {
        return moment(String(value)).format(format)
    }
    return '';
}

export function formatCurrency(value) {
    let val = (value/1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}